export const CONTACT_HOUR = {
  name: 'Em que período pretende ser contactado?',
  fieldName: 'horario',
  values: [
    { label: '9h00 - 11h30', value: '9h00 - 11h30' },
    { label: '11h30 - 13h00', value: '11h30 - 13h00' },
    { label: '13h00 - 15h30', value: '13h00 - 15h30' },
    { label: '15h30 - 18h00', value: '15h30 - 18h00' },
    { label: '18h00 - 20h30', value: '18h00 - 20h30' },
  ],
}

export const POTENCY = {
  name: 'Potência',
  fieldName: 'potencia_contratada',
  values: [
    { label: '1,15 kVA', value: 1.15 },
    { label: '2,3 kVA', value: 2.3 },
    { label: '3,45 kVA', value: 3.45 },
    { label: '4,6 kVA', value: 4.6 },
    { label: '5,75 kVA', value: 5.75 },
    { label: '6,9 kVA', value: 6.9 },
    { label: '10,35 kVA', value: 10.35 },
    { label: '13,8 kVA', value: 13.8 },
    { label: '17,25 kVA', value: 17.25 },
    { label: '20,7 kVA', value: 20.7 },
    { label: '27,6 kVA', value: 27.6 },
    { label: '34,5 kVA', value: 34.5 },
    { label: '41,4 kVA', value: 41.4 },
  ],
}

export const TARIFF = {
  name: 'Tarifa',
  fieldName: 'ciclo_horario',
  values: [
    { label: 'Simples', value: 's' },
    { label: 'Bi-Horário', value: 'b' },
    { label: 'Tri-Horário', value: 't' },
  ],
}

export const BILLING_ADDRESS = {
  name: 'Morada da Faturação',
  fieldName: 'billing_address',
  values: [
    { label: 'Igual à morada de contrato', value: 'e' },
    { label: 'Diferente da morada do contrato', value: 'd' },
  ],
}

export const DIRECT_DEBIT = {
  name: 'Débito direto',
  fieldName: 'direct_debit',
  values: [
    { label: 'Sim', value: 'd' },
    { label: 'Não', value: 'false' },
  ],
}

export const ELETRONIC_BILLING = {
  name: 'Fatura eletrónica',
  fieldName: 'eletronic_billing',
  values: [
    { label: 'Sim', value: 'e' },
    { label: 'Não', value: 'false' },
  ],
}

export const CONTACTS = {
  name: 'Meio de contacto preferêncial',
  fieldName: 'preferential_contact',
  values: [
    { label: 'Email', value: 'e' },
    { label: 'Chamada telefónica', value: 'p' },
    { label: 'SMS', value: 's' },
  ],
}

export const CYCLE = {
  name: 'Ciclo horário',
  fieldName: 'ciclo',
  values: [
    { label: 'Diário', value: 'd' },
    { label: 'Semanal', value: 'w' },
  ],
}

export const TIER = {
  name: 'Escalão',
  fieldName: 'price_step',
  values: [
    { label: 'Escalão 1', value: 1 },
    { label: 'Escalão 2', value: 2 },
    { label: 'Escalão 3', value: 3 },
    { label: 'Escalão 4', value: 4 },
  ],
}



// WEBPACK FOOTER //
// ./src/components/TariffSubscribeForm/data.js